import { Link, useRouterState } from '@tanstack/react-router';

import { cn } from '@shigo-ui/ui/cn';

import { dashboardT } from '../../../../../lib/messages';

export function BlockedListTabs() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const active = pathname.startsWith('/supply/blocked-list/creatives');

  return (
    <nav
      aria-label={dashboardT('blockedList.title')}
      className="border-border bg-card page-gutter border-b"
    >
      <div className="flex min-w-max gap-1 overflow-x-auto">
        <Link
          to="/supply/blocked-list/creatives"
          aria-current={active ? 'page' : undefined}
          className={cn(
            'text-muted-foreground border-b-2 border-transparent px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors',
            active && 'shigo-supply-tab--active',
          )}
        >
          {dashboardT('blockedList.tabs.creatives')}
        </Link>
      </div>
    </nav>
  );
}
